<div class="user-chat">
    <bdi>
        <p class="font-style user-response" [innerHTML]="adminMessage"></p>
    </bdi>
    <span class="material-symbols-outlined user-icon">
        person
    </span>
</div>